const faqItems = [
  {
    q: '黑料吃瓜爆料网的内容来源是什么？',
    a: '我们的内容通过智能算法实时监控全网50余个主流社交平台，包括微博、抖音、快手、小红书、豆瓣、知乎等。同时也有大量热心网友和知情人士通过投稿渠道向我们提供独家线索和爆料内容。',
  },
  {
    q: '如何快速搜索到想看的明星黑料？',
    a: '您可以在首页的话题热榜中浏览当前最热门的话题标签，或通过热门专题索引找到感兴趣的分类内容。我们还提供了实时热搜榜，展示当前热度最高的5条娱乐资讯，帮助您快速定位热门事件。',
  },
  {
    q: '平台上的爆料信息是否真实可靠？',
    a: '我们会对每一条爆料进行多方交叉验证，标注信息来源和可信度等级。标记为"实锤"的内容均已有确凿证据支撑，标记为"爆料"或"跟进"的内容我们会持续追踪更新，建议以官方回应和最终调查结果为准。',
  },
  {
    q: '如何向平台投稿或提供线索？',
    a: '欢迎通过下方的"投稿爆料"入口提交您的独家线索。我们承诺对投稿人信息严格保密，一经采用将给予相应奖励。您也可以通过官方邮箱或社交媒体私信的方式联系我们。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-500 mb-2">FAQ</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">常见问题</h2>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-semibold text-foreground-800 marker:hidden">
                <span className="pr-4">{item.q}</span>
                <span className="w-6 h-6 flex items-center justify-center shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}